import NotificationsPanel from './NotificationsPanel'
import NotificationsPanelItem from './NotificationsPanelItem'

export { NotificationsPanelItem }

export default NotificationsPanel
